import { Grid } from '@mui/material';
import PromoComponent from '../BitcoinRewardsSection/PromoComponent';
import RewardComponent from '../BitcoinRewardsSection/RewardComponent';

export const BannerComponent = () => {
    return (
        <Grid
            container
            alignItems="stretch"
            rowSpacing={{
                xs: 4,
                sm: 0
            }}
            sx={{
                marginTop: '0px !important'
            }}>
            <Grid
                item
                xs={12}
                md={12}
                lg={8}
                sx={{
                    background: '#FFF',
                    paddingTop: '0 !important'
                }}>
                <PromoComponent />
            </Grid>
            <Grid
                item
                xs={12}
                md={12}
                lg={4}
                sx={{
                    paddingTop: '0 !important',
                    marginTop: () => ({
                        xs: '30px',
                        lg: 0
                    })
                }}>
                <RewardComponent />
            </Grid>
        </Grid>
    );
};
